var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldFavoriteChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.44 15.591c.16.32.57.62.91.68l.43.07c1.31.22 1.61 1.18.68 2.12l-.4.4c-.27.27-.41.79-.33 1.17l.05.24c.36 1.58-.48 2.19-1.85 1.36l-.29-.18c-.35-.21-.93-.21-1.28 0l-.29.18c-1.38.83-2.21.22-1.85-1.36l.05-.24c.08-.37-.06-.9-.33-1.17l-.4-.4c-.93-.95-.63-1.9.68-2.12l.43-.07c.35-.06.75-.36.91-.68l.32-.65c.62-1.25 1.62-1.25 2.24 0l.32.65z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.38C2 19.83 4.17 22 7.81 22h5.28c.35 0 .6-.36.56-.71-.04-.38-.02-.83.1-1.35.02-.07 0-.15-.06-.21l-.22-.22c-.85-.86-1.16-1.9-.86-2.85.31-.94 1.17-1.6 2.36-1.8l.3-.05.27-.54c.55-1.12 1.45-1.77 2.46-1.77s1.91.65 2.46 1.77l.15.31c.07.15.21.25.37.28l.27.06c.35.09.75-.19.75-.56V7.81C22 4.17 19.83 2 16.19 2H7.81zm6.14 9.94c-.29.37-.7.61-1.17.66-.46.06-.93-.07-1.29-.36l-1.83-1.42a.22.22 0 0 0-.19-.05c-.04 0-.11.02-.17.1l-2.38 3.09a.758.758 0 0 1-1.06.13.749.749 0 0 1-.14-1.05L8.1 9.95c.29-.37.7-.61 1.17-.67.47-.06.93.07 1.3.36l1.83 1.44c.07.06.14.05.19.05.04 0 .11-.02.17-.1l2.31-2.98c.25-.33.72-.39 1.05-.13.34.25.39.72.14 1.04l-2.31 2.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldFavoriteChart);
export default __webpack_public_path__ + "static/media/vuesax-bold-favorite-chart.462a8cbc56cb40d7b8e8cf3fd56c814a.svg";
export { ForwardRef as ReactComponent };